import { InputBase } from "@mui/material";
import React from "react";
import { ConditionSelectProps } from "@sinch/components/application/RatelistBuilder/RateBuilderRowContent/ConditionInput/ConditionInput";

export const ConditionValueInputString = ({
  onChange,
  value,
  onOpenChange,
  onBlur,
  readOnly,
}: ConditionSelectProps<string>) => (
  <InputBase
    fullWidth
    inputProps={{
      "data-cy": "ConditionInput-valueInput-string",
    }}
    onBlur={(e) => {
      onOpenChange(false);
      onBlur?.(e);
    }}
    onChange={(e) => {
      onChange(e.target.value);
    }}
    onFocus={() => onOpenChange(true)}
    readOnly={readOnly}
    sx={{ px: 1 }}
    value={value ?? ""}
  />
);
